import React from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';

const isInvalid = (val) => {
    return ( ( (typeof val === "string"  && val.trim() === '')  || val === null || val === undefined) && val !== 0);
};

/**
 * Renders children if value prop is valid else defaults to N/A
 * @param children To be rendered while
 * @param value The value to be checked
 * @param invalid Invalid value representation
 * @returns {*}
 * @constructor
 */
const StandardValue = ({ children , value , invalid }) => {

    if(isInvalid(value))
        return <span>{invalid}</span>;

    return (_.isString(value) || _.isNumber(value)) ? <span>{children || value}</span> :  (_.isNil(children) ? null : children);
};

StandardValue.propTypes = {
    value: PropTypes.any,
    invalid: PropTypes.any,
    children: PropTypes.any
};

StandardValue.defaultProps = {
    invalid: "N/A"
};

export default StandardValue;


// WEBPACK FOOTER //
// ./src/common/StandardValue.js